import { render } from "./AlbumLyrics.vue?vue&type=template&id=710abffe"
import script from "./AlbumLyrics.vue?vue&type=script&lang=js"
export * from "./AlbumLyrics.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__